const styles = () => ({
  formControl: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  '@media (max-width: 640px)': {
    label: {
      fontSize: '14px',
    },
  },
})

export default styles
